import markApplyRecordService from "./markApplyRecordService";

const processingMarkApplyRecordService = [
    ...markApplyRecordService
]

export default processingMarkApplyRecordService